import { Col, Row } from "react-bootstrap";

import Button from "../Buttons/Button";
import ConditionWarningText from "./ConditionWarningText";
import ProductImage from "../../../assets/images/productimage.png";
import AddEditInventoryModalProductInfo from "./AddEditInventoryModalProductInfo";
import {
  TcgplayerIcon,
  PricechartingIcon,
  LogoImageReplaceIcon,
} from "../../../assets/icons/iconsProvider";
import {
  isMarketPriceHigh,
  handleViewTCGPlayer,
  handleViewEbaySales,
  handleViewPriceCharting,
  handleUploadProductImage,
  handleBeautifyMarketPrice,
  handleIsViewTcgPlayerApiButton,
  convertToUsd,
  formatCurrency,
  iShowTcgPlayerButtonLogo,
} from "../../utility";
import {
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  categoryDropdownConstants,
} from "../../../constants";
import AddEditInventoryModalProductProperties from "./AddEditInventoryModalProductProperties";
import CategoriesDropdown from "../selectDropdown/CategoriesDropdown";
import { connect } from "react-redux";
import ProductImageCard from "../productDetailCard/ProductImageCard";

const ProductModalHeader = ({
  values,
  productTags,
  selectedTags,
  setProductUrl,
  setFieldValue,
  conditionList,
  setSelectedTags,
  activateSpinner,
  hiddenFileInput,
  productCondition,
  setConditionList,
  productDataObject,
  isEditModal = false,
  deactivateSpinner,
  setProductTagsList,
  setProductCondition,
  setProductDataObject,
  handleConditionChange,
  handleReplaceButtonClick,
  priceChartingProductInfo,
  setPriceChartingProductInfo,
  setAddSelectedTags,
  markupPresets,
  tradeinMargin,
  setIsFirstRender = () => {},
  isConvertToUsd = false,
  currentStore,
}) => {
  return (
    <>
      <Col md={9} className="d-flex flex-column gap-2">
        <div className="d-flex gap-3">
          <div className="add-inventory-product-image">
            <ProductImageCard src={productDataObject?.imgUrl || ProductImage} />
            <input
              type="file"
              className="d-none"
              accept=".png, .jpg, .jpeg"
              onChange={(e) =>
                handleUploadProductImage(
                  e,
                  activateSpinner,
                  deactivateSpinner,
                  productDataObject,
                  setProductDataObject
                )
              }
              ref={hiddenFileInput}
            />
            <button
              onClick={handleReplaceButtonClick}
              type="button"
              className="replace-logo-button"
            >
              <LogoImageReplaceIcon className="replace-icon" />
            </button>
          </div>
          <AddEditInventoryModalProductInfo
            priceChartingProductInfo={productDataObject}
          />
        </div>

        <Row className="w-100">
          <Col md={12} className="gap-3 pt-2">
            {isEditModal ? (
              <AddEditInventoryModalProductProperties
                values={values}
                setFieldValue={setFieldValue}
                setIsFirstRender={setIsFirstRender}
                priceChartingProductInfoComponent={productDataObject}
                setPriceChartingProductInfoComponent={setProductDataObject}
                conditionComponent={{
                  setConditionList: (e) => {
                    setProductDataObject({
                      ...productDataObject,
                      conditionList: e,
                      productConditionList: e,
                    });
                  },
                  productCondition: productCondition,
                  setProductCondition: setProductCondition,
                  component: (
                    <CategoriesDropdown
                      options={productDataObject?.productConditionList || []}
                      handleChange={(selectedOption) => {
                        setIsFirstRender?.(false);
                        handleConditionChange(
                          markupPresets,
                          selectedOption,
                          setProductCondition,
                          productTags,
                          setProductTagsList,
                          setProductDataObject,
                          productDataObject,
                          setSelectedTags,
                          tradeinMargin,
                          setAddSelectedTags,
                          true,
                          setPriceChartingProductInfo
                        );
                      }}
                      noOptionsMessage="No Condition Found"
                      placeholder="Condition"
                      SelectIconImage={
                        categoryDropdownConstants.INVENTORY_LIST_ICON
                      }
                      isClearable={false}
                      className="add-inventory-dropdowns-category condition-dropdown"
                      value={productCondition}
                    />
                  ),
                }}
                // raritiesComponent={{
                //   handleRaritiesChange: (selectedOption) => {
                //     handleRaritiesChange(
                //       selectedOption,
                //       setSelectedRarity,
                //       setProductDataObject,
                //       productDataObject,
                //       tradeinMargin,
                //       markupPresets,
                //       true
                //     );
                //   },
                // }}
              />
            ) : (
              <AddEditInventoryModalProductProperties
                values={values}
                setFieldValue={setFieldValue}
                setIsFirstRender={setIsFirstRender}
                priceChartingProductInfoComponent={productDataObject}
                setPriceChartingProductInfoComponent={setProductDataObject}
                conditionComponent={{
                  setConditionList: setConditionList,
                  productCondition: productCondition,
                  setProductCondition: setProductCondition,
                  component: (
                    <CategoriesDropdown
                      options={conditionList}
                      handleChange={(selectedOption) => {
                        setIsFirstRender?.(false);
                        handleConditionChange(
                          selectedOption,
                          setProductCondition,
                          priceChartingProductInfo,
                          productTags,
                          setProductTagsList,
                          setProductDataObject,
                          productDataObject,
                          setSelectedTags,
                          setPriceChartingProductInfo
                        );
                      }}
                      noOptionsMessage="No Condition Found"
                      placeholder="Condition"
                      SelectIconImage={
                        categoryDropdownConstants.INVENTORY_LIST_ICON
                      }
                      isClearable={false}
                      className="add-inventory-dropdowns-category condition-dropdown"
                      value={productCondition}
                    />
                  ),
                }}
              />
            )}
          </Col>
        </Row>
      </Col>

      {/* Product Refernce Site Buttons. e.g PriceCharting, Tcgplayer*/}
      {priceChartingProductInfo?.productMetaData?.sourceApi ===
        inventoryConstants.PRICECHARTING_API ||
      productDataObject?.apiSource === inventoryConstants.PRICECHARTING_API ? (
        <Col md={3} className="d-flex flex-column align-items-center gap-2">
          <div className=" d-flex justify-content-center align-items-center gap-2 pb-1">
            <span className="fst-italic market-price-heading me-3">
              Market:
            </span>{" "}
            <PricechartingIcon />
            <span
              className={`market-price-text ms-1 ${
                isMarketPriceHigh(
                  handleBeautifyMarketPrice(productDataObject),
                  values.inStockPrice,
                  productTags,
                  selectedTags
                ) && values.inStockPrice
                  ? "text-danger"
                  : ""
              }`}
            >
              {formatCurrency(
                handleBeautifyMarketPrice(
                  productDataObject,
                  true,
                  isConvertToUsd
                )
              )}
            </span>{" "}
            <ConditionWarningText
              priceChartingProductInfo={priceChartingProductInfo}
            />
          </div>
          <div className="border-bottom border-2 w-100 mb-2"></div>
          <div className="w-100 d-flex justify-content-between add-inventory-price-sub-heading">
            <span>Suggested sell price: </span>
            <span>
              {formatCurrency(
                isConvertToUsd
                  ? productDataObject?.suggestedSellPrice || 0
                  : convertToUsd(productDataObject?.suggestedSellPrice || 0)
              )}
            </span>
          </div>
          <div className="w-100 d-flex justify-content-between add-inventory-price-sub-heading">
            <span>Avg. In-Stock Price: </span>
            <span>{formatCurrency(productDataObject?.inStorePrice || 0)}</span>
          </div>
          <Button
            type="button"
            label={buttonNameConstants.VIEW_EBAY_SALES}
            className="w-100"
            handleClick={() =>
              handleViewEbaySales(
                productDataObject?.productName,
                productDataObject?.consoleName,
                productDataObject?.genre
              )
            }
            buttonType={buttonTypeConstants.GREEN_BUTTON}
          />
          <Button
            type="button"
            label={buttonNameConstants.VIEW_PRICE_CHARTING}
            className="w-100"
            handleClick={() =>
              handleViewPriceCharting(priceChartingProductInfo, setProductUrl)
            }
            IconImage={PricechartingIcon}
            buttonType={buttonTypeConstants.BLUE_BUTTON}
          />
        </Col>
      ) : handleIsViewTcgPlayerApiButton(
          priceChartingProductInfo?.productMetaData?.sourceApi ||
            productDataObject?.apiSource
        ) ? (
        <Col md={3} className="d-flex flex-column align-items-center gap-2">
          <div className="d-flex justify-content-center align-items-center gap-2 pb-1 ">
            <span className="fst-italic market-price-heading me-3">
              Market:
            </span>{" "}
            {iShowTcgPlayerButtonLogo(
              priceChartingProductInfo?.productMetaData?.sourceApi ||
                productDataObject?.apiSource,
              currentStore
            ) && <TcgplayerIcon className="tcgplayer-icon" />}
            <span
              className={`market-price-text ms-1 ${
                isMarketPriceHigh(
                  handleBeautifyMarketPrice(productDataObject),
                  values.inStockPrice,
                  productTags,
                  selectedTags
                ) && values.inStockPrice
                  ? "text-danger"
                  : ""
              }`}
            >
              {formatCurrency(
                handleBeautifyMarketPrice(productDataObject, true)
              )}
            </span>
          </div>
          <ConditionWarningText
            priceChartingProductInfo={priceChartingProductInfo}
          />
          <div className="border-bottom border-2 w-100 mb-2"></div>{" "}
          <div className="w-100 d-flex justify-content-between add-inventory-price-sub-heading">
            <span>Suggested sell price: </span>
            <span>
              {formatCurrency(
                convertToUsd(productDataObject?.suggestedSellPrice || 0)
              )}
            </span>
          </div>
          <div className="w-100 d-flex justify-content-between add-inventory-price-sub-heading">
            <span>Avg. In-Stock Price: </span>
            <span>{formatCurrency(productDataObject?.inStorePrice || 0)}</span>
          </div>
          {iShowTcgPlayerButtonLogo(
            priceChartingProductInfo?.productMetaData?.sourceApi ||
              productDataObject?.apiSource,
            currentStore
          ) && (
            <Button
              type="button"
              label={buttonNameConstants.VIEW_TCG_PLAYER}
              className="w-100"
              handleClick={() => handleViewTCGPlayer(productDataObject)}
              buttonType={buttonTypeConstants.LIGHT_PURPLE}
              isDisabled={!productDataObject?.tcgPlayerUrl}
            />
          )}
        </Col>
      ) : null}
    </>
  );
};
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
});
export default connect(mapStateToProps)(ProductModalHeader);
